import geolocator from 'geolocator'
import geolib from 'geolib'
import Spot3d from '@/classes/spot3d'
import Objects3d from '@/classes/objects3d'
import objectsJson from '@/json/objects.json'
import MakeSpot from '@/classes/makeSpot'
// import MakeWinners from '@/classes/makeWinners'

export default class {
  constructor () {
    this.things = []
    this.objects = []
    this.winners = []
    this.winar = []
    this.winnerPos = {}
    this.winarTitle = {}
    this.winnerGroup = new window.THREE.Group()
    this.thingGroup = new window.THREE.Group()
    this.watchLocation = null
    this.spot3d = new Spot3d()
    this.objects3d = new Objects3d()
    this.makeSpot = new MakeSpot()
    //  this.makeWinners = new MakeWinners()
    this.locationOptions = {
      enableHighAccuracy: false,
      timeout: 5000,
      maximumWait: 10000,
      maximumAge: 0,
      desiredAccuracy: 1,
      fallbackToIP: true,
      addressLookup: false,
      timezone: false
    }
    geolocator.config({
      language: 'en',
      google: {
        version: '3',
        key: 'AIzaSyBP498t5dAbPMm_x9CsRzGxSK_wrtZtOnc'
      }
    })
  }
  test () {
    console.log('testar att importera en fil')
  }
  getCurrentLocation (callback) {
    geolocator.locate(this.locationOptions, (err, location) => {
      if (err) return console.log(err)
      callback(location.coords)
    })
  }
  watchCurrentLocation (callback) {
    var options = { enableHighAccuracy: true, timeout: 6000, maximumAge: 0 }
    this.watchLocation = geolocator.watch(options, (err, location) => {
      if (err) return console.log(err)
      //  game.locationUpdateThings(location.coords)
    })
  }
  renderSceneObjects (areakey, coordOrig, scene, callback) {
    let colors = {
      blue: 0x1F5585,
      purple: 0x3B4D78,
      pink: 0x844660,
      yellow: 0xFFC757,
      white: 0xF5F5F5
    }
    let self = this
    for (var i = 0; i < objectsJson.length; i++) {
      let obj = objectsJson[i]
      let mesh = null
      switch (obj.type) {
        case 'tree':
          mesh = this.objects3d[obj.type]()
          break
        case 'mountain':
          if (typeof obj.options.mega !== 'undefined') {
            mesh = this.objects3d[obj.type](colors[obj.options.color], true)
          } else {
            mesh = this.objects3d[obj.type](colors[obj.options.color])
          }
          break
        case 'sphere':
          mesh = this.objects3d[obj.type](colors[obj.options.color], obj.options.size)
          break
        default:
          mesh = this.objects3d[obj.type]()
      }
      let itemCoord = {
        latitude: obj.coordinates[1],
        longitude: obj.coordinates[0]
      }
      let xyz = null
      if (obj.type === 'tree') {
        if (obj.area === areakey) {
          xyz = this.getXY(itemCoord, coordOrig)
          mesh.name = obj.name
          mesh.position.x = xyz.x
          mesh.position.z = xyz.z
          mesh.position.y = obj.y
          self.objects.push({
            name: obj.name,
            mesh: mesh,
            xyz: xyz,
            coordinates: obj.coordinates
          })
          mesh.lookAt({x: 0, z: 0, y: 2})
          scene.add(mesh)
        }
      } else {
        xyz = this.getXY(itemCoord, coordOrig)
        mesh.name = obj.name
        mesh.position.x = xyz.x
        mesh.position.z = xyz.z
        mesh.position.y = obj.y
        self.objects.push({
          name: obj.name,
          mesh: mesh,
          xyz: xyz,
          coordinates: obj.coordinates
        })
        scene.add(mesh)
      }
    }
    /* let mountain1 = this.objects3d.mountain(0x1F5585)
    mountain1.position.set(600, -2, -1600)
    this.objects.add(mountain1)

    let mountain2 = this.objects3d.mountain(0x3B4D78)
    mountain2.position.set(0, -2, -3000)
    this.objects.add(mountain2)

    let mountain3 = this.objects3d.mountain(0x105C66)
    mountain3.position.set(-3000, -2, -3000)
    this.objects.add(mountain3) */
/*
    let cloud1 = this.objects3d.cloud()
    cloud1.position.set(0, 140, -1100)
    scene.add(cloud1) */

    /*
    let cloud2 = this.objects3d.cloud()
    cloud2.position.set(-400, 140, -900)
    scene.add(cloud2) */

    /*
    let cloud3 = this.objects3d.cloud()
    cloud3.position.set(30, 140, -30)
    scene.add(cloud3) */
/*
    let cloud4 = this.objects3d.cloud()
    cloud4.position.set(120, 140, -200)
    scene.add(cloud4)
*/
    /*
    let cloud5 = this.objects3d.cloud()
    cloud5.position.set(50, 140, 140)
    scene.add(cloud5) */

    /*
    let cloud6 = this.objects3d.cloud()
    cloud6.position.set(350, 140, -130)
    scene.add(cloud6) */
    /*
    let sphere1 = this.objects3d.sphere(0xF5F5F5, 200)
    sphere1.position.set(-500, 410, -200)
    this.objects.add(sphere1)

    let sphere2 = this.objects3d.sphere(0xFFC757, 700)
    sphere2.position.set(-1500, 310, 2000)
    this.objects.add(sphere2)

    let tree1 = this.objects3d.tree()
    tree1.position.set(-20, 1, -30)
    this.objects.add(tree1)

    let tree2 = this.objects3d.tree()
    tree2.position.set(50, 1, -10)
    tree2.lookAt({x: 0, z: 0, y: 2})
    this.objects.add(tree2)
    let tree3 = this.objects3d.tree()
    tree3.position.set(10, 1, 10)
    tree3.lookAt({x: 0, z: 0, y: 2})
    this.objects.add(tree3) */

    return this.objects
  }
  renderThings (areakey, coordOrig, items, scene, objects, winners, callback) {
    /* console.log('items:', items)
    console.log('items length:', items.length)
    console.log('first item:', items[0]) */
    if (objects === true) {
      this.renderSceneObjects(areakey, coordOrig, scene)
    }

    //  Exhibit
    let exCoords = {
      latitude: 59.331480,
      longitude: 18.071500
    }
    // Danderyd temp
    /*
    exCoords = {
      latitude: 59.399980,
      longitude: 18.030571
    }
    */
    this.winnerPos.xyz = this.getXY(exCoords, coordOrig)

    // Render exhibit
    for (var u = 0; u < winners.length; u++) {
      let thumb = winners[u].thumburl
      //  console.log(thumb)
      //  let thumb = 'https://firebasestorage.googleapis.com/v0/b/takeitmakeit-b7ef1.appspot.com/o/assets%2Femptyspot.png?alt=media&token=b9b29c6c-57ef-4d65-a72a-0e39271ea036'
      let self = this
      let meshBasicObjectWinner = {color: 0xffffff, side: window.THREE.DoubleSide}
      var textureClosure2 = (u, self) => {
        let textureLoader = new window.THREE.TextureLoader()
        textureLoader.crossOrigin = ''
        textureLoader.load(thumb, (texture) => {
          texture.repeat.set(1, 1)
          texture.needsUpdate = true
          meshBasicObjectWinner = {map: texture, needsUpdate: true, side: window.THREE.DoubleSide}
          self.winar[u].material = new window.THREE.MeshBasicMaterial(meshBasicObjectWinner)
          self.winar[u].material.needsUpdate = true
          self.winar[u].obj.material = self.winar[u].material
        }, (progress) => {}, (error) => {
          console.log(error)
        })
      }
      textureClosure2(u, self)
      let materials = new window.THREE.MeshBasicMaterial(meshBasicObjectWinner)
      let geometrys = new window.THREE.PlaneGeometry(10, 10, 1)
      geometrys.dynamic = true
      geometrys.verticesNeedUpdate = true
      this.winar.push({
        geometry: geometrys,
        material: materials,
        //  material: new window.THREE.MeshBasicMaterial({color: 0xFFFFFF}),
        writable: true,
        name: winners[u].id
      })
      this.winar[u].obj = new window.THREE.Mesh(this.winar[u].geometry, this.winar[u].material)
      this.winar[u].obj.position.z = -4 * u + 50
      this.winar[u].obj.position.x = -4 * u + Math.random() * 100
      this.winar[u].obj.position.y = 40
      this.winar[u].obj.name = winners[u].id
      this.winnerGroup.add(this.winar[u].obj)
    }
    this.winarTitle = this.spot3d.addSoloTitle('Exhibition Stockholm')
    this.winnerGroup.add(this.winarTitle)
    this.winnerGroup.position.z = this.winnerPos.xyz.z
    this.winnerGroup.position.x = this.winnerPos.xyz.x
    this.winnerGroup.position.y = 0
    this.winnerGroup.lookAt({x: 0, z: 0, y: 2})
    scene.add(this.winnerGroup)

    for (var i = 0; i < items.length; i++) {
      //  console.log('item ' + i + ': ', items[i])
      //  Make a empty texture!
      var meshBasicObject = {color: 0xffffff, side: window.THREE.DoubleSide}
      let thumb = 'https://firebasestorage.googleapis.com/v0/b/takeitmakeit-b7ef1.appspot.com/o/assets%2Femptyspot.png?alt=media&token=b9b29c6c-57ef-4d65-a72a-0e39271ea036'
      if ('winner' in items[i] && items[i].winner !== null) {
        thumb = items[i].winner.thumburl
      }
      //  console.log('i before this loads: ', i)
      var self = this
      var textureClosure = (i, self) => {
        let textureLoader = new window.THREE.TextureLoader()
        textureLoader.crossOrigin = ''
        textureLoader.load(thumb, (texture) => {
          texture.repeat.set(1, 1)
          meshBasicObject = {map: texture, needsUpdate: true, side: window.THREE.DoubleSide}
          self.things[i].material = new window.THREE.MeshBasicMaterial(meshBasicObject)
          self.things[i].material.needsUpdate = true
          self.things[i].arobj.material = self.things[i].material
        }, (progress) => {}, (error) => {
          console.log(error)
        })
      }
      textureClosure(i, self)
      let material = new window.THREE.MeshBasicMaterial(meshBasicObject)
      //  let geometry = new window.THREE.SphereGeometry(3, 60, 60)
      let geometry = new window.THREE.PlaneGeometry(10, 10, 1)
      geometry.dynamic = true
      geometry.verticesNeedUpdate = true
      material.needsUpdate = true
      this.things.push({
        geometry: geometry,
        material: material,
        //  material: new window.THREE.MeshBasicMaterial({color: 0xFFFFFF}),
        writable: true,
        name: items[i].name
      })
      var l = this.things.length - 1

      this.things[l].border = new window.THREE.Group()
      /*
      if ('winner' in items[i] && items[i].winner !== null) {
        this.things[l].border.add(this.spot3d.addExhibitTitle(items[i].name, items[i].winner.username))
      } else {
        this.things[l].border.add(this.spot3d.addExhibitTitle(items[i].name, 'Ingen ställer ut än'))
      }
      this.things[l].border.add(this.addChallengeButton(this.things[l].name))
      this.things[l].border.add(this.spot3d.addViewButton(this.things[l].name))
      this.things[l].border.add(this.spot3d.addWhiteBack()) */
      this.things[l].border.add(this.makeSpot.makeBorder())
      this.things[l].border.add(this.spot3d.addConeArrow())
      this.things[l].border.add(this.spot3d.addSoloTitle(this.things[l].name))
      //  this.things[l].border.add(this.spot3d.addSpotSpotLight())
      this.things[l].arobj = new window.THREE.Mesh(this.things[l].geometry, this.things[l].material)
      //  this.things[l].arobj = this.makeSpot.makeSpotPic(thumb, this.things[l])
      if (items[i].coordinates) {
        let itemCoord = {
          latitude: items[i].coordinates.lat,
          longitude: items[i].coordinates.lng
        }
        this.things[l].xyz = this.getXY(itemCoord, coordOrig)
      } else {
        this.things[l].xyz = {x: 0, z: 0}
      }
      //  Winner image in plane
      this.things[l].arobj.position.z = this.things[l].xyz.z
      this.things[l].arobj.position.x = this.things[l].xyz.x
      this.things[l].arobj.position.y = 6
      this.things[l].border.position.z = this.things[l].xyz.z
      this.things[l].border.position.x = this.things[l].xyz.x
      this.things[l].border.position.y = 6
      this.things[l].arobj.name = this.things[l].name
      this.things[l].arobj.lookAt({x: 0, z: 0, y: 8})
      this.things[l].border.lookAt({x: 0, z: 0, y: 8})
      this.things[l].waves = []
      scene.add(this.things[l].arobj)
      scene.add(this.things[l].border)
    }
    typeof callback === 'function' && callback()
  }
  clearThings (scene, camera) {
    for (var i = 0; i < this.things.length; i++) {
      //  clear all waves
      for (var j = 0; j < this.things[j].waves.length; j++) {
        scene.remove(this.things[i].waves[j].mesh)
        this.things[i].waves[j].mesh.geometry.dispose()
        this.things[i].waves[j].mesh.material.dispose()
        this.things[i].waves[j] = null
      }
      //  clear thing
      scene.remove(this.things[i].arobj.mesh)
      scene.remove(this.things[i].border)
      this.things[i].arobj.mesh.geometry.dispose()
      this.things[i].arobj.mesh.geometry.dispose()
      this.things[i].arobj = null
      this.things[i].border.mesh.geometry.dispose()
      this.things[i].border.mesh.geometry.dispose()
      this.things[i].border = null
    }
    this.things = []
  }
  locationUpdateThings (items, coords) {
    // BÖRJA HÄR GÖR SÅ TRÄDEN RÖR SIG!!!
    // Rör winners
    //  Exhibit
    let exCoords = {
      latitude: 59.331480,
      longitude: 18.071500
    }
    // Danderyd temp
    /*
    exCoords = {
      latitude: 59.399980,
      longitude: 18.030571
    }
    */
    this.winnerPos.xyz = this.getXY(exCoords, coords)
    console.log('new winnerpos', this.winnerPos.xyz)
    for (var i = 0; i < items.length; i++) {
      if (items[i].coordinates) {
        let itemCoord = {
          latitude: items[i].coordinates.lat,
          longitude: items[i].coordinates.lng
        }
        let newCoords = this.getXY(itemCoord, coords)
        //  console.log('New COORDS', newCoords)
        this.things[i].xyz = newCoords
        this.things[i].target_xyz = null
      } else {
        this.things[i].xyz = {x: 60, z: 60}
      }
    }
  }
  clickHandler (event, scene, camera, raycaster, mouse, renderer, callback) {
    event.preventDefault()
    mouse.x = (event.clientX / renderer.domElement.clientWidth) * 2 - 1
    mouse.y = -1 * (event.clientY / renderer.domElement.clientHeight) * 2 + 1
    raycaster.setFromCamera(mouse, camera)
    let objects = this.winar.map((a) => {
      return a.obj
    })
    /*
    let objects = []
    for (var i = 0; i < this.things.length; i++) {
      objects = objects.concat(this.things[i].border.children)
    }; */
    let intersects = raycaster.intersectObjects(objects)
    typeof callback === 'function' && callback(intersects)
  }
  getUpdatedPosition (oldCoords, newCoords) {
    let maxDelta = (dist) => {
      return Math.abs(dist) / 70
    }
    let currentDist = Math.sqrt(Math.pow(oldCoords.x, 2) + Math.pow(oldCoords.z, 2))
    if (currentDist >= 60) {
      return newCoords
    }
    let newC = {
      x: newCoords.x,
      z: newCoords.z
    }
    if (typeof oldCoords.x !== 'undefined' && typeof newC.x !== 'undefined') {
      let delta = {
        x: newC.x - oldCoords.x,
        z: newC.z - oldCoords.z
      }
      let maxX = maxDelta(newC.x)
      if (Math.abs(delta.x) > maxX && delta.x !== 0) {
        newC.x = oldCoords.x + (maxX * (delta.x / Math.abs(delta.x)))
      }
      let maxZ = maxDelta(newC.z)
      if (Math.abs(delta.z) > maxZ && delta.z !== 0) {
        newC.z = oldCoords.z + (maxZ * (delta.z / Math.abs(delta.z)))
      }
      return newC
    } else {
      return newCoords
    }
  }
  updateThings (scene, camera) {
    //  const maxDistance = 260
    //  const wavelength = 40
    //  console.log('first obj', this.things[0].arobj.geometry)
    let shortestDistance = null
    //  let shortestThing = null
    //  console.log('things', this.things)

    //  Update winner
    //  console.log('things #:', this.things)

    //  Update winner position
    //  let winnerNew = this.getUpdatedPosition(this.winnerGroup.position, this.winnerPos.xyz)
    if (this.winnerPos.xyz) {
      //  let winnerNew = this.winnerPos.xyz
      let winnerNew = this.getUpdatedPosition(this.winnerGroup.position, this.winnerPos.xyz)
      this.winnerGroup.position.z = winnerNew.z
      this.winnerGroup.position.x = winnerNew.x
      this.winnerGroup.lookAt({x: 0, z: 0, y: 2})
      this.winnerGroup.updateMatrix()
      //  console.log(winnerNew)
      shortestDistance = Math.sqrt(Math.pow(winnerNew.z, 2) + Math.pow(winnerNew.x, 2))
    }

    for (var i = 0; i < this.things.length; i++) {
      //  console.log('To send', this.things[i].xyz)
      let newCoords = this.getUpdatedPosition(this.things[i].arobj.position, this.things[i].xyz)
      //  this.things[i].target_xyz = newCoords
      //  console.log('New coords', newCoords)
      //  console.log('To be updated:', this.things[i].xyz)
      //  let newCoords = this.things[i].xyz
      //  console.log(scene)
      //  let check = scene.getObjectByName(this.things[i].name)
      //  scene.remove(this.things[i].arobj)
      this.things[i].arobj.position.z = newCoords.z
      this.things[i].arobj.position.x = newCoords.x
      this.things[i].border.position.z = newCoords.z
      this.things[i].border.position.x = newCoords.x
      this.things[i].arobj.lookAt({x: 0, z: 0, y: 8})
      this.things[i].border.lookAt({x: 0, z: 0, y: 8})
      //  scene.add(this.things[i].arobj)

      //  this.things[i].border.mesh.geometry.verticesNeedUpdate = true
      //  console.log(this.things[i].arobj)
      //  waves
      var closestDistance = Math.sqrt(Math.pow(newCoords.x, 2) + Math.pow(newCoords.z, 2))
      if (shortestDistance === null) {
        shortestDistance = closestDistance
        //  shortestThing = this.things[i]
      }
      if (shortestDistance > closestDistance) {
        shortestDistance = closestDistance
        //  shortestThing = this.things[i]
      }
      //  console.log(shortestDistance)
      //  return
      /*
      if (this.things[i].waves.length < 1 && closestDistance < maxDistance) {
        this.things[i].waves.push({ mesh: this.makeNewWave(1, camera), radius: 1 })
        this.things[i].waves[0].mesh.position.x = newCoords.x
        this.things[i].waves[0].mesh.position.z = newCoords.z
        this.things[i].waves[0].mesh.rotation.set(-90 * (3.14 / 180), 0, 0, 'XYZ')
        scene.add(this.things[i].waves[0].mesh)
      } else if (this.things[i].waves.length < 1 && closestDistance >= maxDistance) {

      } else if (this.things[i].waves.length > 0 && closestDistance > maxDistance) {
        for (var j = 0; j < this.things[i].waves.length; j++) {
          scene.remove(this.things[i].waves[j].mesh)
          this.things[i].waves[j].mesh.geometry.dispose()
          this.things[i].waves[j].mesh.material.dispose()
        }
        this.things[i].waves = []
      } else {
        for (var k = 0; k < this.things[i].waves.length; k++) {
          this.things[i].waves[k].radius += 0.4
          var tempPos = this.things[i].waves[k].mesh.position.clone()
          scene.remove(this.things[i].waves[k].mesh)
          this.things[i].waves[k].mesh.geometry.dispose()
          if (this.things[i].waves[k].radius < maxDistance) {
            this.things[i].waves[k].mesh.geometry = this.makeNewWaveLine(this.things[i].waves[k].radius).geometry
            this.things[i].waves[k].mesh.position.x = tempPos.x
            this.things[i].waves[k].mesh.position.z = tempPos.z
            scene.add(this.things[i].waves[k].mesh)
          } else {
            this.things[i].waves[k].mesh.material.dispose()
            this.things[i].waves[k] = false
          }
        }
        this.things[i].waves = this.things[i].waves.filter((n) => { return n !== false })
        if (this.things[i].waves.length > 0 && this.things[i].waves[this.things[i].waves.length - 1].radius > wavelength) {
          var index = this.things[i].waves.length
          this.things[i].waves[index] = { mesh: this.makeNewWave(2, camera), radius: 2 }
          this.things[i].waves[index].mesh.position.x = newCoords.x
          this.things[i].waves[index].mesh.position.z = newCoords.z
          this.things[i].waves[index].mesh.rotation.set(-90 * (3.14 / 180), 0, 0, 'XYZ')
          scene.add(this.things[i].waves[index].mesh)
        }
      } */
    }
    return { thing: 'kungsan', dist: shortestDistance }
  }
  makeNewWaveLine (rad) {
    var segmentCount = 60
    var radius = rad
    var geometry = new window.THREE.Geometry()

    for (var i = 0; i <= segmentCount; i++) {
      var theta = (i / segmentCount) * Math.PI * 2
      geometry.vertices.push(
          new window.THREE.Vector3(
              Math.cos(theta) * radius,
              Math.sin(theta) * radius,
              0))
    }
    geometry.vertices.push(geometry.vertices[0].clone())
    var line = new window.MeshLine()
    line.setGeometry(geometry)
    return line
  }
  makeNewWave (rad, camera) {
    var line = this.makeNewWaveLine(rad)
    var material = new window.MeshLineMaterial({
      lineWidth: 0.1,
      color: new window.THREE.Color(0xFFFFFF),
      side: window.THREE.FrontSide,
      near: camera.near,
      far: camera.far
    })

    var mesh = new window.THREE.Mesh(line.geometry, material)
    mesh.rotation.set(-90 * (3.14 / 180), 0, 0, 'XYZ')
    mesh.position.y = -6
    mesh.geometry.writable = true
    mesh.position.writable = true
    return mesh
  }
  getXY (coord, coordOrig) {
    var d = geolocator.calcDistance({
      from: coordOrig,
      to: coord,
      formula: geolocator.DistanceFormula.PYTHAGOREAN,
      unitSystem: geolocator.UnitSystem.METRIC
    }) * 1000
    var b = geolib.getBearing(
      coordOrig,
      coord
    )
    var z = -1 * (Math.cos(b * Math.PI / 180) * d)
    var x = 1 * (Math.sin(b * Math.PI / 180) * d)
    return {
      x: x,
      z: z
    }
  }
}



// WEBPACK FOOTER //
// ./src/classes/ArgameEx.js